<template>
  <div class="border" :style="bottom ? 'width:95%' : ''">
    <div ref="carousel" @wheel="scroll" class="footbal-carusel">
      <div class="footbal-card" v-for="(item, index) in football" :key="index">
        <div class="liga">
          <div class="liga__title">{{ item.league_name }}</div>
          <div class="liga__img img">
            <img :src="item.league_logo" alt="Liga" />
          </div>
        </div>
        <div class="teams">
          <div class="command">
            <div class="command__img img">
              <img :src="item.home_icon" alt="comand" />
            </div>
            <div class="command__name">{{ item.home_team }}</div>
            <div class="command__score">{{ item.home_goal }}</div>
          </div>
          <div class="command">
            <div class="command__img img">
              <img :src="item.away_icon" alt="comand" />
            </div>
            <div class="command__name">{{ item.away_team }}</div>
            <div class="command__score">{{ item.away_goal }}</div>
          </div>
        </div>
        <div class="match-time" v-html="timeAgo(item.date)"></div>
      </div>
    </div>
  </div>
</template>
<script>
import { useStore } from "vuex";
import { computed, ref } from "vue";
import { useFormatter } from "@/utils/formatter";

export default {
  name: "FootbalTournaments",
  props: {
    bottom: {
      type: Boolean,
      default: true
    }
  },
  setup() {
    const store = useStore();
    const carousel = ref(null);

    store.dispatch("football");
    const scroll = e => {
      e = window.event || e;
      carousel.value.scrollLeft += e.deltaY;
      e.preventDefault();
    };

    return {
      football: computed(() => store.getters.football),
      carousel,
      scroll,
      ...useFormatter()
    };
  }
};
</script>
<style lang="scss" scoped>
.border {
  position: relative;
  margin: 0 auto;
  width: 90%;
  margin-bottom: 0.6em;
  &::after {
    content: "";
    position: absolute;
    height: 1px;
    width: 100%;
    bottom: 0;
    left: 0;
    background: #fff;
  }
  @media screen and (max-width: 992px) {
    width: 100%;
    &::after,
    &::before {
      content: "";
      position: absolute;
      height: 1px;
      width: 80%;
      left: 50%;
      transform: translateX(-50%);
      background: #fff;
    }
    &::after {
      bottom: 0;
    }

    &::before {
      top: 0;
    }
  }
  @media screen and (max-width: 767px) {
    &::after,
    &::before {
      width: 100%;
    }
  }
}
.footbal-carusel {
  padding-top: 0.5em;
  padding-bottom: 0.5em;
  position: relative;
  display: flex;
  width: 100%;
  margin: 0 auto;
  overflow-x: auto;
  scrollbar-width: none;
  // scroll-behavior: smooth;
  // scroll-snap-type: x mandatory;

  &::-webkit-scrollbar-track {
    // -webkit-box-shadow: inset 0 0 2px rgba(0, 0, 0, 0.3);
    background-color: #f5f5f5;
  }

  &::-webkit-scrollbar {
    width: 0;
    height: 0px;
    border-radius: 50%;
    background-color: #f5f5f5;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #a7a7a7;
    border: 1px solid #fff;
  }
}
@media screen and (max-width: 1920px) {
  .footbal-carusel {
    .footbal-card {
      .icon {
        width: 2.5em;
        height: 2.5em;
      }
      .time {
        font-size: 1.4em;
        .day {
          font-size: 0.7em;
        }
      }
      .name,
      .score {
        font-size: 1em;
      }
      .team-lost {
        // если команда проиграла то серый цвет букв
        color: #939393;
      }
    }
  }
}

@media screen and (max-width: 1300px) {
  .footbal-carusel {
    .footbal-card {
      min-width: calc(100% / 4);
    }
  }
}
@media screen and (max-width: 992px) {
  .footbal-carusel {
    transform: translateX(4rem);
  }
}
@media screen and (max-width: 767px) {
  .footbal-carusel {
    width: 100vw;
    // overflow-x: scroll;
    transform: translateX(0rem);

    .footbal-card {
      min-width: calc(100% / 3);
      padding: 0.5rem 1rem 0 1rem;
    }
  }
}
@media screen and (max-width: 475px) {
  .footbal-carusel {
    margin-bottom: 0.5rem;
    .footbal-card {
      min-width: calc(100% / 2);
    }
  }
}
img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  background: transparent;
}
.img {
  width: 1.5em;
  height: 1.5em;
}
.teams {
  // display: flex;
  width: 100%;
}
.match-time {
  height: 100%;
}
.command {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 40px;
  gap: 0.5rem;
  font-size: 1em;
  &__name {
    flex: 1;
  }
}
.footbal-card {
  scroll-snap-align: start;
  position: relative;
  box-sizing: border-box;
  min-width: calc(100% / 6);
  height: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  padding: 1em;
  color: #fff;
  font-family: Roboto;
  position: relative;
  flex: 0 0 270px;
  &:first-child {
    padding-left: 0;
    @media screen and (max-width: 992px) {
      padding-left: 1em;
    }
  }
  &:last-child::after {
    background: transparent;
  }
  &::after {
    content: "";
    position: absolute;
    right: 0;
    width: 1px;
    height: 75%;
    background: #fff;
  }

  .liga {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    font-size: 0.87em;
    .liga__img {
      flex: 0 0 2.9em;
      width: 2.9em;
      height: 2.9em;
    }
  }
}
</style>
